import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";

// Components
import PurchaseOrderPromoTable from "./PurchaseOrderPromoTable";
import PurchaseAddItem from "./PurchaseAddItem";
import PurchaseEditShipping from "./PurchaseEditShipping";
import LoadingModal from "../../components/Modal/LoadingModal";
import PurchaseOrderWholesaleTable from "./PurchaseOrderWholesaleTable";

//React Router (for getting parameters)
import { useParams, useHistory } from "react-router-dom";

//number format plugin
import numeral from "numeral";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { NavLink } from "react-router-dom";

import MessageBox from "../../components/MessageBox/MessageBox";

//cookies
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";

//customize buttons default and disabled color
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Preloader from "../../components/Preloader/Preloader";
import { Autocomplete } from "@material-ui/lab";
import LoadingOverlay from "react-loading-overlay";
import PopUpModal from "../../components/Modal/PopUpModal";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #59b259",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#4f537e",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700px",
    textTransform: "uppercase",
    color: "#00000",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "rgba(89, 178, 89, 0.09)",
    padding: "1rem",
    border: "1.5px solid #59b259",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #59b259",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  root: {
    "&$disabled": {
      color: "#f2f2f2",
    },
  },
  disabled: {
    backgroundColor:'gray',
    
  },
});

const PurchaseOrderWholesaleInformation = () => {
  const { supid, delivery_date, country, atype, freight,maximumSetCount} = useParams();
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [supplier, setSupplier] = useState(null);
  const [warehouse, setWarehouse] = useState(null);
  const classes = useStyles();

  const [items, setItems] = useState([]); //data to display in PO table
    const [itemsTable, setItemsTable] = useState([]); //data to display in PO table
  const [supplierItem, setSupplierItem] = useState(null); //data to display in Add Item dropdown
  const [promoType, setPromoType] = useState([]);
  const [poTotal, setPoTotal] = useState(0);
  const [shipTotal, setShipTotal] = useState(0);
  const [notes, setNotes] = useState("");
  const [packageamount, setPackageAmount] = useState(0.0);
  const [packageList, setPackageList] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");

  const [modalOpen, setModalOpen] = useState(false);
  const [messageType, setMessageType] = useState("info");
  const [popUpMessage, setPopUpMessage] = useState("");
  //Message Box EOF

  //state for managing loading modal
  const [showModal, setShowModal] = useState(false);

  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [btnDisabledAdd, setBtnDisabledAdd] = useState(true);
  let history = useHistory();
  //Loading overlay
  const [showOverlay, setShowOverlay] = useState(false);
  const [qty, setQty] = useState(null);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);
  //
  useEffect(() => {
    if(maximumSetCount<=1 || atype == "Platinum" || atype=="Startup"){
      setQty(1);
    }
  }, [maximumSetCount,atype])
  

  const save_po = async () => {
    setShowOverlay(true);
    setBtnDisabled(true); // disable button to avoid multiple saves
    setShowModal(true); //show loading/please wait modal

    const formData = new FormData();
    formData.append("packages", JSON.stringify(itemsTable));
    formData.append("trandate", delivery_date);
    formData.append("jc_user_id_no", get_cookies("branchidno"));
    formData.append("curcode", promoType.curcode);
    formData.append("jc_username", get_cookies("username"));
    formData.append("shippingfreight", freight);
    formData.append("promotype", promoType.packagetypename);
    formData.append("packagetotalamount", packageamount);
    formData.append("packages_selected", "YES");
    formData.append("pofrom", supid);
    // console.log('itemsTable',itemsTable);

    await axios
      .post(process.env.REACT_APP_API_URL + "save_po_promo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        setShowOverlay(false);
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Added new PO");
        setMsgType("success");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push("/purchases/purchases-order-wholesale");
        }, 2000);
      })
      .catch(function (error) {
        setShowOverlay(false);
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  const addItem = () => {
    
    if(qty == 0|| qty == null|| qty == undefined){
      return;
    }
      const getTotalQty = (items) =>
  items.reduce((sum, item) => Number(sum) +  Number(item.qty), 0);
      setItems(prevItems => {
              const newQty = Number(qty) || 1;
        const currentTotal = getTotalQty(prevItems);
            if (Number(currentTotal) + newQty > Number(maximumSetCount)) {
                    setShowModal(false);
      setPopUpMessage(
        "NOTE: You cannot add more set since you have reached the number of set needed for this transaction."
      );
      setModalOpen(true);
      setMessageType("warning");
      setTimeout(() => {
        setShowModal(false);
        // setBtnDisabled(false); // re-enable
      }, 2500);
      return prevItems; // ❌ do not update
    }

      const addItems = Array.from({ length: qty == null?1:qty }, () => ({
          id: selectedItem.id,
          item_id: selectedItem.id,
          item_name: selectedItem.description,
      }));
      
      setItemsTable([...itemsTable, ...addItems])

        const existItem = prevItems.find(
          item => item.id === selectedItem.id
        );
        if(existItem){
          return prevItems.map(item=> item.id === selectedItem.id ?{...item,qty:Number(item.qty)+Number(qty)}:item)
        }
        return [
        ...items,
        {
          id: selectedItem.id,
          item_id: selectedItem.id,
          item_name: selectedItem.description,
          qty: promoType.packagetype === "Startup" || promoType.packagetype==="Platinum" ?1:qty,
        },
      ];
    });
    
    //     let found = items.some((x) => x.id === selectedItem.id);
    //     if (found) {
    //if item is existing in itemArray, add the qty instead
    //       let newItems = items.map((it) => {
    //         if (selectedItem.id === selectedItem.description) {
    //           //add
    //           it.qty += item.qty;
    //         }
    //         return it;
    //       });
    //       setItems(newItems);
    //     } else {
    //add new unique item to array

    //     }
  };

  const deleteItem = (item_id) => {
    //console.log(item_id);
    let itemArray = items.filter((item) => item.item_id !== item_id);
    setItems(itemArray);
  };

  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
    //console.log('refresh sir');
  }, []);

  //update PO total when items update
  useEffect(() => {
    // let po_total = 0;
    // items.forEach(item => po_total += (item.price*item.qty))
    // setPoTotal(po_total);
    if (itemsTable.length == Number(maximumSetCount)) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
    // // if(items.length > 0) {
    // // 	setBtnDisabled(false); // re-enable
    // // }else{
    // // 	setBtnDisabled(true); // re-enable
    // }
    if (selectedItem.length < maximumSetCount) {
      setBtnDisabledAdd(true); // re-enable
    } else {
      setBtnDisabledAdd(false); // re-enable
    }
    // console.log('aaa',items);
  }, [selectedItem, items,itemsTable]);

  const data = async () => {
    //get data for single supplier

    await axios
      .get(process.env.REACT_APP_API_URL + "get_single_wholesaleset", {
        params: {
          country: country, //supplier_id
          atype: atype,
        },
      })
      .then((res) => {
        setPromoType(res.data.data.info);
        setPackageAmount(res.data.data.info.wholesale_price);
        axios
          .get(
            process.env.REACT_APP_API_URL +
              "get_product_package_list_wholesale",
            {
              params: {
                country: country, //supplier_id
                atype: maximumSetCount > 1 ?"Platinum":atype,
              },
            }
          )
          .then((res) => {
            setPackageList(res.data.data.info);
          })
          .catch((error) => {
            // console.log(error.message);
          });
      })
      .catch((error) => {
        // console.log(error.message);
      });

    // await axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
    // 	params:{
    // 		supplier_id: supid,  //supplier_id
    // 	}
    // }).then((supplier_item_result)=>{
    // 	setSupplierItem(supplier_item_result.data.data);
    // }).catch((error)=>{
    // //console.log(error.message);
    // });
  };

  const selectPackage = {
    options: packageList,
    getOptionLabel: (option) => option.description,
  };

  const ColorButton = withStyles(() => ({
    root: {
      color: "#fff",
      backgroundColor: "#4caf50",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#4caf50",
      },
      "&:disabled": {
        backgroundColor: "#d3d3d3!important",
        color: "#9e9e9e",
      },
    },

  }))(Button);

  return (
    <div className="page">
      <LoadingOverlay active={showOverlay} spinner text={"Processing . . ."}>
        <PopUpModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          message={popUpMessage}
          type={messageType}
        />
        <div className="page-header">
          <div className="page-icon">
            <LoyaltyTwoTone />
          </div>
          <NavLink to={"/purchases"}>
            <h4 style={{ color: "#1D1C1A" }}>Purchases</h4>
          </NavLink>
          <ArrowForwardIosIcon
          fontSize="small" color="disabled"
       
          />
          <NavLink to={"/purchases/purchases-order-wholesale"}>
            <h4 style={{ color: "#1D1C1A" }}>Wholesale Set Purchase Order</h4>
          </NavLink>
          <ArrowForwardIosIcon
          fontSize="small" color="disabled"

          />
          <h4>
            Purchase Order {promoType.packagetype} - {promoType.packagetypename}
          </h4>
        </div>
        {promoType ? (
          <div className="page-container">
            <MessageBox
              in={showMsgBox}
              content={msgBoxContent}
              type={msgType}
            />
            <Card className={classes.card}>
              <div className={classes.cardHeader}>
                <Grid
                  container
                  spacing={0}
                  style={{ justifyContent: "flex-end" }}
                >
                  <Grid item xs={12}>
                    <div className={classes.subTitle}>
                      Purchase Order Information
                    </div>
                  </Grid>
                </Grid>
              </div>
              <CardContent>
                <div className={classes.infoContainer}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={2} className={classes.infoTitle}>
                      Date of Delivery:
                    </Grid>
                    <Grid item xs={12} sm={10} className={classes.infoContent}>
                      {delivery_date || ""}
                    </Grid>
                  </Grid>
                  {/* <Grid container spacing={3}>
                  <Grid item xs={12} sm={2} className={classes.infoTitle}>
                    Wholesale Price
                  </Grid>
                  <Grid item xs={12} sm={10} className={classes.infoContent}>
                    {promoType.curcode || ""} {promoType.wholesale_price || ""}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={2} className={classes.infoTitle}>
                    Wholesale Count:
                  </Grid>
                  <Grid item xs={12} sm={10} className={classes.infoContent}>
                    {promoType.wholesale_count || ""}
                  </Grid>
                </Grid> */}
                  {/* <Grid container spacing={3}>
                  <Grid item xs={12} sm={2} className={classes.infoTitle}>
                  Paid Account:
                  </Grid>
                  <Grid item xs={12} sm={10} className={classes.infoContent}>
                   0
                  </Grid>
                </Grid> */}
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={2} className={classes.infoTitle}>
                      Account Type:
                    </Grid>
                    <Grid item xs={12} sm={10} className={classes.infoContent}>
                      {promoType.packagetype || ""}
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                      <Grid item xs={12} sm={2} className={classes.infoTitle}>
                        Account Type Name:
                      </Grid>
                      <Grid item xs={12} sm={10} className={classes.infoContent}>
                        {promoType.packagetypename || ""}
                      </Grid>
                    </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={2} className={classes.infoTitle}>
                      Maximum Set Count:
                    </Grid>
                    <Grid item xs={12} sm={10} className={classes.infoContent}>
                      {maximumSetCount || ""}
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={2} className={classes.infoTitle}>
                      Wholesale Set Price:
                    </Grid>
                    <Grid item xs={12} sm={10} className={classes.infoContent}>
           
                      {promoType.curcode + " " +  numeral(promoType.wholesale_price).format('0,0.00') ||
                        ""}
                    </Grid>
                  </Grid>
                  {/* <Grid container spacing={3}>
                  <Grid item xs={12} sm={2} className={classes.infoTitle}>
                  FS Accounts: 
                  </Grid>
                  <Grid item xs={12} sm={10} className={classes.infoContent}>
                    {promoType.free_accounts+ " Accounts" || ""}
                  </Grid>
                </Grid> */}
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={2} className={classes.infoTitle}>
                      Purchase From:
                    </Grid>
                    <Grid item xs={12} sm={10} className={classes.infoContent}>
                      {supid}
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={2} className={classes.infoTitle}>
                      Frieght:
                    </Grid>
                    <Grid item xs={12} sm={10} className={classes.infoContent}>
                      {freight == "nofreight" ? "-" : freight}
                    </Grid>
                  </Grid>
                </div>
                <Autocomplete
                  {...selectPackage}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  className={classes.autoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Set"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  onChange={(event, newValue) => {
                    if (!newValue == [] || !newValue == null) {
                      // console.log(newValue);
                      setSelectedItem(newValue);
                    } else {
                      setSelectedItem([]);
                    }
                  }}
                />
                {maximumSetCount >1 ?<TextField
                              label="Qty"
                              variant="outlined"
                            type="number"
                              value={qty || ''}
                              className={classes.textarea}
                              onChange={(e)=>{
                                const  value =e.target.value
                                if(value === ""){
                                  setQty(null);
                                  return;
                                }else if(!/^\d{0,10}$/.test(value)){
                                      return;
                                }
                                // const num = Number(value);
                                // if(num >= MIN && )
                                setQty(value)}}
                            />:null}

                <ColorButton
                  variant="contained"
                  disabled={btnDisabledAdd}
                  style={{ marginBottom: 10 }}
                  color="primary"
                  classes={{
                    root: classes.root,
                    disabled: classes.disabled,
                  }}
                  onClick={addItem}
                >
                  add
                </ColorButton>
                <PurchaseOrderWholesaleTable
                  items={items}
                  setItems={setItems}
                  deleteItem={deleteItem}
                  setItemsTable={setItemsTable}
                />
              </CardContent>
            </Card>
            <div className={classes.buttonContainer}>
              {/* <Button variant="contained">Back</Button> */}
              <ColorButton
                disabled={btnDisabled}
                variant="contained"
                color="primary"
                classes={{
                  root: classes.root,
                  disabled: classes.disabled,
                }}
                onClick={save_po}
              >
                Save
              </ColorButton>
            </div>
          </div>
        ) : (
          <Preloader />
        )}
      </LoadingOverlay>
    </div>
  );
};

export default PurchaseOrderWholesaleInformation;
